export default __webpack_public_path__ + "static/media/promos1.0a93276e.webp";